// src/utils/alertModal.js
import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { AlertTriangle } from "lucide-react";

export function showAlert({ title, message }) {
  const containerId = "global-alert-modal-root";
  let container = document.getElementById(containerId);
  if (!container) {
    container = document.createElement("div");
    container.id = containerId;
    document.body.appendChild(container);
  }

  const root = createRoot(container);

  function AlertModal() {
    useEffect(() => {
      const onKey = (e) => {
        if (e.key === "Enter" || e.key === "Escape") {
          window.location.href = "/project_setting";
        }
      };
      document.addEventListener("keydown", onKey);
      return () => document.removeEventListener("keydown", onKey);
    }, []);

    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center animate-fade-in">
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
        {/* Dialog */}
        <div className="relative mx-4 w-full max-w-sm rounded-2xl border border-gray-700 bg-gray-900 text-white shadow-2xl overflow-hidden">
          {/* Header Accent */}
          <div className="flex items-center gap-2 px-6 py-4 bg-gradient-to-r from-red-500 to-pink-600">
            <AlertTriangle className="w-6 h-6 text-white" />
            <h3 className="text-lg font-semibold">{title}</h3>
          </div>

          {/* Body */}
          <div className="px-6 py-5 text-center">
            <p className="text-gray-300 leading-relaxed">{message}</p>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 flex justify-center bg-gray-800/50">
            <button
              onClick={() => (window.location.href = "/project_setting")}
              className="w-full py-2.5 rounded-lg bg-gradient-to-r from-red-500 to-pink-600 text-white font-semibold hover:opacity-95 transition-all"
            >
              확인
            </button>
          </div>
        </div>
      </div>
    );
  }

  root.render(<AlertModal />);
}
